// extracted by extract-css-chunks-webpack-plugin
module.exports = {"videoContainer":"WElvK","videoPlay":"_0pukE"};